import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "./context/UserContext";
import { NotificationError } from "./components/Utils/Notification";

const ProtectedRoute = ({
  children,
  workerDisabled = false,
  adminRequired = false,
  sellerRequired = false,
  architectRequired = false,
}) => {
  const { isLoggedIn, user, userSet, token } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect to login if not authenticated
  if (!isLoggedIn || !token) {
    console.log(
      "User is not logged in or token is missing. Redirecting to login.",
    );
    console.log(isLoggedIn, token, window.location.href, location.pathname);
    return (
      <Navigate
        to={`/zaloguj-sie?next=${encodeURIComponent(location.pathname)}`}
        replace={true}
      />
    );
  }

  // Check admin requirements
  if (adminRequired && !user?.is_admin) {
    userSet();
    navigate("/zaloguj-sie", { replace: true });
    NotificationError("Brak uprawnień administratora");
    return null;
  }

  // Check seller requirements
  // TODO: refine seller check logic
  if (
    sellerRequired &&
    !(user?.is_superuser || user?.is_worker || user?.is_admin)
  ) {
    userSet();
    NotificationError("Brak uprawnień sprzedawcy");
    navigate("/zaloguj-sie", { replace: true });
    return null;
  }

  // Check architect requirements
  if (
    architectRequired &&
    !(user?.is_superuser || user?.is_worker) &&
    !user?.is_admin
  ) {
    userSet();
    NotificationError("Brak uprawnień projektanta");
    navigate("/zaloguj-sie", { replace: true });
    return null;
  }

  // Worker access restrictions
  if (workerDisabled && user?.is_worker && !user?.is_superuser) {
    navigate(-1);
    return null;
  }

  return children;
};

export default ProtectedRoute;
